
const Subscriptions = require('../../../../../utils/domain/security/subscriptions')
const rmsApiProxy = require('../../../../../utils/api/rmsApiProxy.js');
const currentOrgNodeSelectors = require('../../../../../utils/state/stateSelectors/currentOrgNodeSelectors');
const stateManager = require('../../../../../utils/state/stateManager');



export async function load()
{
    const resourceUrl = `${rmsApiProxy.getPropertyOrgContextUrl()}/licenseSubscriptions`;
    return await rmsApiProxy.get(resourceUrl);
}

export async function loadLicenseUsageForFranchisor()
{
    const resourceUrl = `${rmsApiProxy.getFranchiseeOrgContextUrl()}/licenseSubscriptions`;
    return await rmsApiProxy.get(resourceUrl);
}

export async function save(propertyLicenseSubscriptions)
{
    const resourceUrl = `${rmsApiProxy.getPropertyOrgContextUrl()}/licenseSubscriptions`;
    return await rmsApiProxy.post(resourceUrl, propertyLicenseSubscriptions);
}

export function getAllSubscriptions()
{
    return Array.from(Object.keys(Subscriptions.Subscriptions));
}

export function getCurrentFranchisorLicenseUsage()
{
    var franchisorLicenseUsage = stateManager.getStore().getState().franchisorLicenseUsage;
    return franchisorLicenseUsage;
}


export function getCurrentPropertySubscriptions()
{
    var propertyLicenseSubscriptions = stateManager.getStore().getState().propertyLicenseSubscriptions;
    var currentOrgNode = currentOrgNodeSelectors.selectCurrentOrgNode();

    if (propertyLicenseSubscriptions.has(currentOrgNode.propertyId))
        return propertyLicenseSubscriptions.get(currentOrgNode.propertyId);

    return [];
}